import React, { useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import { useCurrentUserContext } from '../../../../../../context/UserContext';

export type GroupAssignedProps = {
    show?: boolean
    loading?: boolean
    onClose: (yes: boolean) => void;
    message?: string;
}

const GroupAssigned: React.FC<GroupAssignedProps> = (props) => {
    const { profile: userProfile } = useCurrentUserContext();

    const handleClose = () => {
        props.onClose && props.onClose(false);
    };

    const handleConfirm = () => {
        // Logic to assign the ticket to the current user before closing
        //console.log('Ticket assigned to the current user and closed.');
        props.onClose && props.onClose(true);
    };

    if (!props.show) return null;

    return (
        <div>
            {props?.loading && <PartialSpinny />}
            <Dialog className='cool-window' title={"Assign to yourself?"} onClose={handleClose} width={400}>
                <p>{props.message ? props.message : `The ${userProfile?.Phrases.CallPhrase} cannot be closed when exclusively assigned to a Group. Would you like to assign the ${userProfile?.Phrases.CallPhrase} to yourself before closing?`}</p>
                <DialogActionsBar layout='center'>
                    <Button size='large' svgIcon={svg.checkIcon} onClick={handleConfirm} style={{ backgroundColor: userProfile?.Nav_Hex_Color, color: 'white' }}>
                        Yes
                    </Button>
                    <Button size='large' svgIcon={svg.xIcon} fillMode='outline' onClick={handleClose}>
                        No
                    </Button>
                </DialogActionsBar>
            </Dialog>
        </div >
    );
};

export default GroupAssigned;